export const REGISTER_LIMITS = {
  NAME_MIN: 2,
  NAME_MAX: 100,
  ORG_NAME_MIN: 2,
  ORG_NAME_MAX: 100,
  PASSWORD_MIN: 8,
} as const;

export const REGISTER_PASSWORD_REGEX = {
  HAS_NUMBER: /\d/,
  HAS_SYMBOL: /[^A-Za-z0-9]/,
} as const;

// E.164 phone format: optional +, 7–15 digits, no leading 0
export const PHONE_E164_REGEX = /^\+?[1-9]\d{6,14}$/;

// Minimal ISO 3166-1 alpha-2 list with dial codes. Expand or replace with full
// list when backend confirms supported countries.
export interface CountryEntry {
  code: string; // ISO 3166-1 alpha-2
  name: string;
  dial: string; // E.164 dial code without leading '+'
}

export const COUNTRIES: ReadonlyArray<CountryEntry> = [
  { code: "MX", name: "México", dial: "52" },
  { code: "CO", name: "Colombia", dial: "57" },
  { code: "AR", name: "Argentina", dial: "54" },
  { code: "BR", name: "Brasil", dial: "55" },
  { code: "CL", name: "Chile", dial: "56" },
  { code: "PE", name: "Perú", dial: "51" },
  { code: "ES", name: "España", dial: "34" },
  { code: "US", name: "United States", dial: "1" },
  { code: "GB", name: "United Kingdom", dial: "44" },
  { code: "PT", name: "Portugal", dial: "351" },
];

export const REGISTER_API_ENDPOINTS = {
  REGISTER: "/auth/register",
  VERIFY_EMAIL: "/auth/verify-email",
  RESEND_VERIFICATION: "/auth/resend-verification",
  CHANGE_VERIFICATION_EMAIL: "/auth/verification-email",
} as const;

// Suffix appended when deriving Org.name suggestion from User.name.
export const ORG_NAME_SUGGESTION_SUFFIX = " Organization";

// The legal page links moved to `@/shared/constants/legal`: the verification flow links to them too, and it
// is served to people who have no account and never see a sign-up form.

// Email verification.
export const OTP_LENGTH = 6;
// UI-side cooldown for the resend button. Backend rate-limits at 3/min.
export const RESEND_COOLDOWN_SECONDS = 30;
